import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { fetchStartWithForward } from '../../../../redux/actions/common'
import { trim } from '../../../../_metronic/helpers'
import { MaintenanceModeBanner } from '../../../../_metronic/helpers/components/MaintenanceModeBanner'
import { AlexiApplicationTypes } from '../../../../utils/constants/AlexiApplicationType.enum'
import { getStoredEnv } from '../../../../utils/getIntegrationURLFromENV'
import { useHistory, useParams } from 'react-router-dom'
import { parse } from 'query-string'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { deleteApplicationDetails } from '../redux/actions'
import { parsePhoneNumberWithError } from 'libphonenumber-js/max'
import { scrollToErros } from '../../loanApplication/steps/Step1Sub1'

const Step1Sub1: FC<any> = ({
  onSuccessCreateApplicaton,
  sendOTP,
  createApplication,
  mobileNo,
  applicantName,
}) => {
  const dispatch = useDispatch()
  const params: any = useParams()
  const history = useHistory()

  const searchQuery: any = parse(history.location.search)

  const savedApplicationDetails = useSelector(
    (state: any) => state.kycApplication.applicationDetails
  )

  const initialValues = {
    applicantName: applicantName ? applicantName : searchQuery?.name || '',
    mobileNumber: mobileNo ? mobileNo : '',
  }

  const validationSchema = Yup.object().shape({
    applicantName: Yup.string()
      .required('Business Owner Name is required')
      .matches(
        /^[A-Za-z\s.']+$/,
        'Please enter a valid Business Owner Name using letters, spaces, periods, or apostrophes, and include at least 2 letters.'
      )
      .test(
        'at-least-two-letters',
        'Business Owner Name cannot contain only special characters. Please enter a valid business owner name.',
        (value: any) => {
          if (!value) return false
          const letters = value.match(/[A-Za-z]/g)
          return (letters?.length || 0) >= 2
        }
      ),
    mobileNumber: Yup.string()
      .required('Mobile number is required')
      .test('mobileValidation', 'Only Singapore numbers are allowed.', (value: any) => {
        if (!value) return false
        try {
          // Use libphonenumber-js to validate phone number format
          const number = parsePhoneNumberWithError(value, 'SG')
          // Explicitly check if the phone number is from Singapore
          return (
            isValidPhoneNumber(value, 'SG') &&
            number.isValid() &&
            number.country === 'SG' &&
            number.country === 'SG'
          )
        } catch (error) {
          return false
        }
      }),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: savedApplicationDetails || initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const { applicantName, mobileNumber } = trim(values)

      dispatch(fetchStartWithForward())

      if (!params?.id && !searchQuery?.mobileNo && !searchQuery?.name) {
        createApplication({
          variables: {
            data: {
              applicantName,
              mobileNumber,
              applicationStatus: 'in-progress',
              applicationCompleteStep: 1.1,
              applicationType: AlexiApplicationTypes.KYC_ONBOARDING,
              partnerId: localStorage.getItem('partnerId') || '',
              credilinqEnvironment: getStoredEnv(),
            },
          },
        })
      } else {
        sendOTP({
          variables: {
            mobileNo,
            isApplicantOrShareholder: true,
            isCoApplicantKYB: false,
          },
        })
        onSuccessCreateApplicaton.reset()
        localStorage.setItem('loanApplicationId', params.id)
      }
      setSubmitting(false)
    },
  })

  useEffect(() => {
    return () => {
      dispatch(deleteApplicationDetails())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className='d-flex flex-column'>
      <div className='cardNew'>
        <MaintenanceModeBanner />
        <div className='section-heading'>
          <h2>Welcome</h2>
          <hr className='text-gray-400' />
        </div>
        <div className='sub-heading text-secondary-400 fs-4 mb-10'>
          Please proceed to complete the Business & Director verification with Myinfo
          business/Corppass and Myinfo singpass
        </div>
        <form onSubmit={formik.handleSubmit} noValidate>
          <div className='row mb-10'>
            <div className='col-md-6 mb-5 '>
              <label htmlFor='' className='input-field-label fw-bold required'>
                Applicant Name
              </label>
              <div className='col-sm-12'>
                <input
                  name='applicantName'
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  value={formik.values.applicantName}
                  onChange={formik.handleChange}
                  disabled={!!searchQuery?.name}
                />
                {formik.touched.applicantName && formik.errors.applicantName && (
                  <div className='text-danger mt-2'>{formik.errors.applicantName}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label fw-bold required'>
                Mobile Number
              </label>
              <div className='col-sm-12'>
                <PhoneInput
                  id='mobileNumber'
                  international
                  defaultCountry='SG'
                  // countryCallingCodeEditable={false}
                  value={formik.values.mobileNumber}
                  onChange={(value) => formik.setFieldValue('mobileNumber', value)}
                  placeholder='Enter phone number'
                  className='int-phone-input'
                  disabled={!!searchQuery?.mobile}
                />
                {(formik.touched.mobileNumber || formik.values.mobileNumber === undefined) &&
                  formik.errors.mobileNumber && (
                    <div className='text-danger mt-2'>{formik.errors.mobileNumber}</div>
                  )}
              </div>
            </div>
          </div>

          <div className='d-flex flex-end'>
            <button
              type='submit'
              className='button button-primary me-3'
              onClick={() => {
                scrollToErros()
              }}
            >
              Send OTP
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export { Step1Sub1 }
